import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// Removed Redux auth selectors - now using useAuth() hook
import { useAuth } from '../context/AuthContext';
import { selectUserFacilities } from '../redux/slices/facilitiesSlice';
import { useFacilityChangeListener } from './useFacilityChangeListener';
import { EncounterType } from '../types/enums';

export function useTriageVisibility() {
  const [shouldShowTriage, setShouldShowTriage] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const { user } = useAuth();
  const userFacilities = useSelector(selectUserFacilities);

  // Listen for facility changes and refresh user facilities
  const handleFacilityChange = (newFacilityId, previousFacilityId) => {
    console.log('Triage visibility: Facility changed, refreshing user facilities');
    // dispatch(fetchUserFacilities()); // Removed: now loaded centrally in AuthContext
  };

  useFacilityChangeListener(handleFacilityChange);

  useEffect(() => {
    const checkTriageVisibility = () => {
      if (!user || !userFacilities || userFacilities.length === 0) {
        setShouldShowTriage(false);
        setLoading(false);
        return;
      }

      // Get the facility to check - either default facility or first available
      let facilityToCheck = null;
      
      if (user.defaultFacility) {
        // Check if default facility exists in user's facilities
        facilityToCheck = userFacilities.find(f => f.id === user.defaultFacility);
      }
      
      // If no default facility or default facility not found, use first available
      if (!facilityToCheck && userFacilities.length > 0) {
        facilityToCheck = userFacilities[0];
      }

      if (!facilityToCheck) {
        setShouldShowTriage(false);
        setLoading(false);
        return;
      }

      // Check if the facility has "Emergency Visit" as an encounter type
      const hasEmergencyVisit = facilityToCheck.encounterTypes && 
        facilityToCheck.encounterTypes.includes(EncounterType.EMERGENCY_VISIT);

      setShouldShowTriage(hasEmergencyVisit);
      setLoading(false);
    };

    checkTriageVisibility();
  }, [user, userFacilities]);

  return { shouldShowTriage, loading };
} 